import asyncComponent from '../common/utils/async-component';

const Members = asyncComponent(() => import('./components/members'));
const ProjectSettings = asyncComponent(() => import('./components/settings'));
const Delinquent = asyncComponent(() => import('./components/delinquent'));
const AccountSettings = asyncComponent(() => import('../auth/components/account-settings'));

export default {
  '/members': {
    components: { main: Members }
  },
  '/settings': {
    components: { main: ProjectSettings }
  },
  '/delinquent': {
    components: { main: Delinquent }
  },
  '/account-settings': {
    components: { main: AccountSettings }
  }
};
